'use strict';

angular.module('pmtPlacesApp.services').service('LocationEditService', [
	'$http',
	'$q',
	'pmtSiteInfoService',
	function ($http, $q, pmtSiteInfoService) {
		const httpErrorUserMessage = err => {
			const data = err && err.data;
			if (typeof data === 'string') {
				return data;
			}
			if (data && typeof data === 'object') {
				if (data.error && typeof data.error.message === 'string') {
					return data.error.message;
				}
				if (typeof data.message === 'string') {
					return data.message;
				}
			}
			return (err && err.statusText) || 'Request failed';
		};

		const confirmGeoLocation = function (siteName, placeId) {
			let deferred = $q.defer();
			let url = 'api/' + siteName + '/places/' + placeId + '/geolocation/confirm';
			$http.post(url, {}).then(
				function (result) {
					deferred.resolve(result.data);
				},
				function (err) {
					deferred.reject(err);
				}
			);

			return deferred.promise;
		};
		const savePartial = (siteName, placeId, updateObj, withoutWork) => {
			const url = 'api/' + siteName + '/places/' + placeId + '/partialUpdate';

			return $http.put(url, updateObj).then(({ status: httpStatus, data }) => {
				if (httpStatus === 202 && data.success) {
					if (withoutWork !== true) {
						pmtSiteInfoService.addWork();
					}
					return data.data;
				}
				throw data.data;
			});
		};

		const updateAllPartial = function (siteName, placeId, updateObj) {
			let deferred = $q.defer();
			let url = `api/${siteName}/places/partialUpdate/?returnPlaceId=${placeId}`;
			pmtSiteInfoService.addWork();
			$http.put(url, updateObj).then(
				function (res) {
					let data = res.data;
					if (res.status === 202 && data.success) {
						deferred.resolve(data.data);
					} else {
						deferred.reject(res.data.data);
					}
				},
				function (err) {
					deferred.reject(err);
				}
			);

			return deferred.promise;
		};

		const updateMultiplePartial = (siteName, locationId, locations, updateObj, withoutWork) => {
			let deferred = $q.defer();
			if (!Array.isArray(locations) || locations == null) {
				deferred.reject('locations must be an non empty array');
				return deferred.promise;
			}
			if (typeof locations[0] !== 'string') {
				deferred.reject('items in the locations array must be strings');
				return deferred.promise;
			}
			if (locationId === undefined) {
				locationId = locations[0];
			}

			const url = `api/${siteName}/places/partialUpdateMultiple/?returnPlaceId=${locationId}`;

			$http.put(url, { locations: locations, updateData: updateObj }).then(
				function (res) {
					let data = res.data;
					if (res.status === 202 && data.success) {
						if (withoutWork !== true) {
							pmtSiteInfoService.addWork();
						}
						deferred.resolve(data.data);
					} else {
						deferred.reject(res.data.data);
					}
				},
				function (err) {
					deferred.reject(httpErrorUserMessage(err));
				}
			);

			return deferred.promise;
		};

		const updateMultipleSpecialOpenHours = function (siteName, updateObj) {
			let deferred = $q.defer();
			let partial = '/places/addSpecialOpenHours/';
			let url = 'api/' + siteName + partial;
			pmtSiteInfoService.addWork();
			$http.put(url, updateObj).then(
				function (res) {
					let data = res.data;
					if (res.status === 202) {
						deferred.resolve(data.data);
					} else {
						deferred.reject(res.data.data);
					}
				},
				function (err) {
					deferred.reject(err);
				}
			);

			return deferred.promise;
		};

		const hasDiff = function (place, newValue, diffProperty) {
			return (
				(place.fb && !angular.equals(newValue, place.fb.data[diffProperty])) ||
				(place.google && !angular.equals(newValue, place.google.data[diffProperty]))
			);
		};

		const validKeys = function (siteName) {
			let url = 'api/' + siteName + '/places/tags';
			return $http.get(url).then(function (response) {
				if (response && response.data && response.data.success) {
					return response.data.data;
				} else {
					return $q.reject(response.data.data);
				}
			});
		};

		return {
			confirmGeoLocation: confirmGeoLocation,
			savePartial: savePartial,
			updateMultiplePartial: updateMultiplePartial,
			updateAllPartial: updateAllPartial,
			hasDiff: hasDiff,
			updateMultipleSpecialOpenHours: updateMultipleSpecialOpenHours,
			validKeys: validKeys
		};
	}
]);
